document.querySelectorAll('[data-surface-listing]').forEach(root=>{
  const grid=root.querySelector('.bb-surface-selection-grid');
  const cards=[...grid.children];
  const update=()=>{
    const families=[...root.querySelectorAll('[data-family]:checked')].map(x=>x.value);
    const prices=[...root.querySelectorAll('[data-price-filter]:checked')].map(x=>x.value);
    const sort=root.querySelector('[data-sort]').value;
    const ordered=cards.slice();
    if(sort!=='featured')ordered.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort==='low'?1:-1));
    let total=0;
    ordered.forEach(card=>{
      const title=card.querySelector('h3').textContent;
      const price=Number(card.dataset.price);
      const bucket=price<1000?'under1000':price<2000?'1000to2000':'over2000';
      const visible=(!families.length||families.some(f=>title.includes('Surface '+f)))&&(!prices.length||prices.includes(bucket));
      card.hidden=!visible;total+=Number(visible);grid.append(card);
    });
    root.querySelector('[data-result-count]').textContent=total+' '+(total===1?'result':'results');
    root.querySelector('[data-empty]').hidden=total!==0;
  };
  root.addEventListener('change',update);
  root.querySelector('[data-clear]').addEventListener('click',()=>{root.querySelectorAll('input').forEach(x=>x.checked=false);update()});
  update();
});
